
<ng-container *ngIf="editorConfiguration">

    <editor [init]="editorConfiguration" [formControl]="control" [apiKey]="TinyMCEApiKey"></editor>
    
</ng-container>
